import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./ResetPassword.css";
import { default as Header } from "../../Components/Header2/Header2";
import { default as Footer } from "../../Components/Footer/FooterSmall";
import useAPI from "../../Hooks/useAPI";
import SecHeader from "../../Components/SecHeader/SecHeader";
import Input from "../../Components/Input/Input";
import Button2 from "../../Components/Button2/Button2";
import { Console } from "console";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { resetPassword } = useAPI();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    const token = searchParams.get("token");
    if (!token) {
      setError("Invalid reset link");
      return;
    }

    try {
      await resetPassword(token, newPassword);
      setSuccess(
        "Password has been reset successfully. You can now login with your new password.",
      );
      setTimeout(() => {
        navigate("/user-login");
      }, 3000);
    } catch (err) {
      setError("Invalid reset link");
    }
  };

  return (
    <>
      <div className="generalPage">
        <Header />
        <div className="pageContainer">
          <div className="reset-password-title-container">
            <div className="sectionContainer">
              <SecHeader title="Reset Password" iSize={3} />
            </div>
            <div className="reset-password-container">
              <div className="reset-password-card">
                <p className="reset-password-subtitle">
                  Please enter your new password below.
                </p>

                {error && <div className="error-message">{error}</div>}

                {success && <div className="success-message">{success}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-label" htmlFor="newPassword">
                      New Password
                    </label>
                    <Input
                      label=""
                      type="password"
                      id="newPassword"
                      placeholder="Enter your password"
                      required={true}
                      name="newPassword"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label" htmlFor="confirmPassword">
                      Confirm New Password
                    </label>
                    <Input
                      label=""
                      type="password"
                      id="confirmPassword"
                      placeholder="Confirm password"
                      required={true}
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>

                  <Button2
                    name="submit"
                    text="Reset Password"
                    type="button"
                    classname="submit-btn"
                  />
                </form>

                <div className="mt-4 text-center">
                  <Button2
                    name="submit"
                    text="Back to Login"
                    type="button"
                    classname="cancel-btn"
                    onClick={() => navigate("/user-login")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
